import { render, staticRenderFns } from "./SidebarSummaryCounts.vue?vue&type=template&id=28ee2171&"
import script from "./SidebarSummaryCounts.vue?vue&type=script&lang=js&"
export * from "./SidebarSummaryCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports